import {
  AcademicManagementGroup,
  AcademicManagementInternshipLocation,
  AcademicManagementProfessional,
  AcademicManagementTask,
} from 'domain/models';
import { TableColumn } from 'react-data-table-component';
import { Badge } from 'reactstrap';

import {
  ActivityStatusSummaryCell,
  WorkloadStatusSummaryCell,
} from '../../../components/academic-management-status-summary';

export const makeAcademicManagementGroupColumns =
  (): TableColumn<AcademicManagementGroup>[] => [
    {
      name: 'Grupo',
      selector: (row) => row.group.name,
      minWidth: '260px',
      wrap: true,
      cell: (row) => (
        <div className="py-2">
          <div>{row.group.name}</div>
          <div className="text-muted small">{row.group.code}</div>
        </div>
      ),
    },
    {
      name: 'Professores',
      selector: (row) => row.professionalCount.teachers,
      center: true,
      minWidth: '110px',
    },
    {
      name: 'Preceptores',
      selector: (row) => row.professionalCount.preceptors,
      center: true,
      minWidth: '110px',
    },
    {
      name: 'Estudantes',
      selector: (row) => row.studentCount,
      center: true,
      minWidth: '110px',
    },
    {
      name: 'Atividades',
      minWidth: '420px',
      cell: (row) => (
        <ActivityStatusSummaryCell status={row.activityStatusCount} />
      ),
    },
  ];

export const makeAcademicManagementTaskColumns =
  (): TableColumn<AcademicManagementTask>[] => [
    {
      name: 'Tarefas',
      selector: (row) => row.taskName,
      minWidth: '260px',
      wrap: true,
    },
    {
      name: 'Atividades',
      minWidth: '420px',
      cell: (row) => (
        <ActivityStatusSummaryCell status={row.activityStatusCount} />
      ),
    },
    {
      name: 'Carga Horária',
      minWidth: '280px',
      cell: (row) => (
        <WorkloadStatusSummaryCell workload={row.workloadStatusSum} />
      ),
    },
  ];

export const makeAcademicManagementInternshipLocationColumns =
  (): TableColumn<AcademicManagementInternshipLocation>[] => [
    {
      name: 'Local de estágio',
      selector: (row) => row.internshipLocationName,
      minWidth: '260px',
      wrap: true,
    },
    {
      name: 'Atividades',
      minWidth: '420px',
      cell: (row) => (
        <ActivityStatusSummaryCell status={row.activityStatusCount} />
      ),
    },
    {
      name: 'Carga Horária',
      minWidth: '280px',
      cell: (row) => (
        <WorkloadStatusSummaryCell workload={row.workloadStatusSum} />
      ),
    },
  ];

export const makeAcademicManagementProfessionalColumns =
  (): TableColumn<AcademicManagementProfessional>[] => [
    {
      name: 'Profissional',
      minWidth: '260px',
      cell: (row) => (
        <div className="d-flex my-2 gap-2 align-items-center">
          <span>{row.professional.name}</span>
          <Badge>{row.professional.roleName}</Badge>
        </div>
      ),
    },
    {
      name: 'Atividades',
      minWidth: '420px',
      cell: (row) => (
        <ActivityStatusSummaryCell status={row.activityStatusCount} />
      ),
    },
    {
      name: 'Carga Horária',
      minWidth: '280px',
      cell: (row) => (
        <WorkloadStatusSummaryCell workload={row.workloadStatusSum} />
      ),
    },
  ];
